export default function Logo({ variant = "dark", size = 40, showText = true }) {
  const isDark = variant === "dark";
  const navy = "#0B1F3A";
  const gold = "#D4AF37";
  const warm = "#F8F7F2";
  const textColor = isDark ? navy : warm;
  const bgColor = isDark ? warm : navy;

  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="First Providence Capital"
      >
        {/* Shield */}
        <path
          d="M32 3 L58 12 V32 C58 46 46 56 32 61 C18 56 6 46 6 32 V12 Z"
          fill={isDark ? navy : navy}
          stroke={gold}
          strokeWidth="1.5"
        />
        {/* Inner monogram F P */}
        <path d="M20 20 H36 M20 20 V44 M20 30 H32" stroke={gold} strokeWidth="2.5" strokeLinecap="square" fill="none" />
        <path d="M40 20 V44 M40 20 H46 A6 6 0 0 1 46 32 H40" stroke={warm} strokeWidth="2.5" strokeLinecap="square" fill="none" />
        {/* Gold rule */}
        <line x1="14" y1="50" x2="50" y2="50" stroke={gold} strokeWidth="1" />
      </svg>
      {showText && (
        <div className="leading-tight">
          <div
            className="font-display text-[18px] tracking-tight"
            style={{ color: textColor }}
          >
            First Providence
          </div>
          <div
            className="text-[10px] tracking-[0.28em] uppercase font-medium"
            style={{ color: isDark ? "#5F6B7A" : "rgba(248,247,242,0.7)" }}
          >
            Capital
          </div>
        </div>
      )}
    </div>
  );
}
